import React from "react";
import styles from "./column.module.css";

const Column = ({ id, children }) => (
  <div id={id} className={styles.column}>{children}</div>
);

export default Column;